import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GlobalStyle = createGlobalStyle`
    ${reset};

    body,html {
      height: 100%;
    }

    body {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      box-sizing: border-box;
      line-height: 1.5;
      font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
    }
    body.modal-open {
      overflow: hidden; 
    }

    * {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      margin: 0;
      padding: 0;
      font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
    }

    button, input {
      -moz-appearance: none; /* Firefox */
      -webkit-appearance: none; /* Safari and Chrome */
      appearance: none;
    }
    
    menu, ol, ul {
      list-style: none;
    }

    a {
        text-decoration: none;
    }

    .page_wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100vh;
      background-image: url("/img/background/background-web-view.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .page_flexbox {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .page_container {
      width: 360px;
      height: 720px;
      box-sizing: border-box;
      padding-bottom: 57px;
      margin: 0 auto;
      margin-left: 100px;
      position: relative;
      top:0;
      left: 0;
      border-top: 10px solid #ffffff;
      border-bottom: 10px solid #ffffff;
      border-left: 6px solid #ffffff;
      border-right: 6px solid #ffffff;
      background-color: #ffffff;
      filter: drop-shadow(5px 5px 30px rgba(0, 0, 0, 0.15));
      border-radius: 12px;
      overflow: hidden;

      @media (max-width:420px) {
        position : fixed;
        top : 0;
        bottom : 0;
        width: 100vw;
        height: 100%;
        margin: 0;
        border: none;
        border-radius: 0;
      }

      #page_section {
        height: 100%;
        overflow-y: scroll;
        ::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .background-text {
      width: 710px;
      height: 574px;
      background-image: url("/img/background/background-web-view-text.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      @media (max-width:420px) {
       display: none;
      }
    }
`;

export default GlobalStyle;
